import { render } from "./Widget8.vue?vue&type=template&id=977597ac"
import script from "./Widget8.vue?vue&type=script&lang=ts"
export * from "./Widget8.vue?vue&type=script&lang=ts"
script.render = render

export default script